module.exports = __webpack_public_path__ + "img/edit.8cca80ef.svg";